import { P2GLinkGroup } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import P2GContentDropDown from '../../P2GContentDropDown';
import { ParcelCountPicker } from './ParcelCountPicker';

interface props {
  options: number;
  selected: number;
  onClick: (q: number) => void;
  groupingControl: ReactNode;
  children: ReactNode;
}

export const SplitWithDropDown: React.FC<props> = (props) => {
  if (props.options === 0) {
    return <P2GLinkGroup pt={1} links={[props.groupingControl as any]} />;
  }

  return (
    <P2GLinkGroup
      pt={1}
      links={[
        <P2GContentDropDown control={props.children} key={props.selected}>
          <div style={{ width: '300px' }}>
            <ParcelCountPicker
              availableParcels={props.options}
              selected={props.selected}
              onSelect={props.onClick}
              justify="center"
            />
          </div>
        </P2GContentDropDown>,
        props.groupingControl as any
      ]}
    />
  );
};
